import { defineComponent as _defineComponent } from 'vue'
import src from '@/utils/filters/src';
import { computed } from 'vue';

interface MonitorPreviewCardProps {
  entity: any // change type later on
}

type DatasetNameAndType = {
  datasetName: string,
  datasourceType: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Monitor-Preview-Card',
  props: {
  entity: null
},
  setup(__props) {

const props = __props;



const ruleLabel = computed(() => props.entity?.ruleLabel ?? '');
const name = computed(() => props.entity.name);
const datasources = computed(() => props.entity?.datasetNameAndSourceTypeDtos?.map((datasource: DatasetNameAndType) => ({
  name: datasource.datasetName,
  type: datasource.datasourceType,
  icon: src(datasource.datasourceType, 'datasources'),
})));

return { __sfc: true,props, ruleLabel, name, datasources, src, computed }
}

})